module.exports = __webpack_public_path__ + "58c389098a53f708c13b00e5dc50c243.png";